import { ReactElement, useState } from 'react';
import "./InfoTooltip.scss";
import { Typography } from "src/latest/src/components";

type Placement = 'top' | 'right' | 'bottom' | 'left';

type Props = {
  className?: string;
  description: ReactElement;
  placement?: Placement;
};

export const InfoTooltip = ({ className, description, placement = 'right' }: Props) => {
  const [isShow, setIsShow] = useState(false);
  let timeOut: ReturnType<typeof setTimeout>;

  const onHover = () => {
    setIsShow(true);
    clearTimeout(timeOut);
  };

  const onTimeOut = () => {
    timeOut = setTimeout(() => {
      setIsShow(false);
    }, 200);
  };

  return (
    <div className={`info info--${placement} ${className} d-flex`}>
      <div
        className="info__icon cursor-pointer"
        onClick={onHover}
        onMouseEnter={onHover}
        onMouseLeave={onTimeOut}
      />
      <div
        className={`info__desc ${isShow ? 'info-show' : ''}`}
        onMouseEnter={onHover}
        onMouseLeave={onTimeOut}
      >
        <Typography variant="size-12" color="color-2" weight="regular">
          {description}
        </Typography>
      </div>
    </div>
  );
};
